import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 5h-6a7 7 0 1 0 0 14h6a7 7 0 0 0 7 -7l-.007 -.303a7 7 0 0 0 -6.993 -6.697z","key":"svg-0"}]]

const IconCapsuleHorizontalFilled = createReactComponent('filled', 'capsule-horizontal-filled', 'CapsuleHorizontalFilled', __iconNode);

export default IconCapsuleHorizontalFilled;